import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Flex } from 'reflexbox'
import List from './List'
import Title from './Title'
import AddButton from './AddButton'
import Input from 'components/fulcrum/input/Input'
import FormTitle from 'components/fulcrum/formTitle/FormTitle'
import {IconButton} from 'react-toolbox/lib/button'

class MultiInput extends Component {
  static propTypes = {
    hint: PropTypes.string,
    title: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    onAdd: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
  }

  static defaultProps = {
    hint: '',
  }

  onRemove(index) {
    return () => this.props.onRemove(index)
  }

  onChange(index) {
    return (value) => this.props.onChange(index, value)
  }

  generateRow(value, index){
    const { title, hint } = this.props
    const label = `${title} ${index + 1}`
    return (
      <FormTitle key={label} title={label}>
        <Input
          value={value}
          hint={hint}
          onChange={this.onChange(index)}
        />
        <IconButton
          primary
          icon='delete'
          onClick={this.onRemove(index)}
        />
      </FormTitle>
    )
  }

  generateFields(){
    return this.props.values.map(({value}, index) => (
      this.generateRow(value, index)
    ))
  }

  render() {
    const { onAdd, title } = this.props
    return (
      <div>
        <List>
          <Flex justify='space-between'>
            <Title label={title}/>
            <AddButton onClick={onAdd}/>
          </Flex>
          { this.generateFields() }
        </List>
      </div>
    )
  }
}

export default MultiInput
